import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../components/layout-components/ContentLayout";
import "./Role.scss";
import AppContext from "../../config/AppContext";
import { useTranslation } from "react-i18next";
import { Box, Radio, FormControl, FormControlLabel, RadioGroup } from "@mui/material";
import CustomButton from "../../components/CustomButton";
import CancelDialog from "../project/CancelDialog";
import { useNavigate } from "react-router-dom";
import { getCompanySetting, updateBudgetType } from "../../services/CompanySettingService";
import { toast } from "sonner";

function Project({ onClose }) {
    const { mode } = useContext(AppContext);
    const { t } = useTranslation();
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const [currentBudgetType, setCurrentBudgetType] = useState(null);
    const navigate = useNavigate();
    const [budgetType, setBudgetType] = React.useState(null);

    useEffect(() => {
        loadBudgetType();
    }, []);

    const loadBudgetType = () => {
        getCompanySetting()
            .then((res) => {
                if (res.data.code === "RCI0000") {
                    setBudgetType(res.data.data.preferences.budgetType);
                    setCurrentBudgetType(res.data.data.preferences.budgetType);
                } else {
                    setBudgetType("all");
                    setCurrentBudgetType("all");
                }
            });
    }

    const handleCloseCancelDialog = () => {
        setIsCancelDialogOpen(false);
    };

    const handleConfirmCancel = () => {
        setIsCancelDialogOpen(false);
        navigate(-1);
    };

    const handleCancelClick = () => {
        if (budgetType !== currentBudgetType) {
            setIsCancelDialogOpen(true);
        } else {
            navigate(-1);
        }
    };

    const handleBudgetTypeChange = (event) => {
        setBudgetType(event.target.value);
    };

    const handleSave = () => {
        const payload = {
            "preferences": {
                "budgetType": budgetType
            }
        }
        updateBudgetType(payload).then((res) => {
            if (res.data.code === "RCI0055") {
                setCurrentBudgetType(budgetType);
                toast.success(t("RAL1166"));
            }else { 
                toast.error(t("RAL0689"));
            }
        }).catch((error) => {
            console.error("Error updating budget type:", error);
        });
    };

    const hasChanges = budgetType !== null && currentBudgetType !== null && budgetType !== currentBudgetType;

    return (
        <ContentLayout
            title={t("RAL0167")}
            type="form"
            navBack={false}
            subtitle={t("RAL1179")}
        >
            <div>
                <div>
                    <span className="role-name">{t("RAL1168")}</span>
                </div>
                <div>
                    <FormControl>
                        <RadioGroup
                            id="btn-toggle-radio-project"
                            sx={{
                                flexDirection: "column",
                                display: "flex",
                                gap: "20px",
                            }}
                            value={budgetType || ""}
                            onChange={handleBudgetTypeChange}
                        >
                            <Box>
                                <FormControlLabel
                                    id="btn-radio-time-project"
                                    className="radio-time-project"
                                    name="btn-radio-time-project"
                                    value="time"
                                    control={
                                        <Radio
                                            id="btn-radio-time-project"
                                            sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                        />
                                    }
                                    label={
                                        <div>
                                            <div className="radio-title">{t("RAL1169")}</div>
                                            <div className="radio-subtitle">{t("RAL1170")}</div>
                                        </div>
                                    }
                                />
                            </Box>
                            <Box>
                                <FormControlLabel
                                    id="btn-radio-cost-project"
                                    className="radio-time-project"
                                    name="btn-radio-cost-project"
                                    value="cost"
                                    control={
                                        <Radio
                                            id="btn-radio-cost-project"
                                            sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                        />
                                    }
                                    label={
                                        <div>
                                            <div className="radio-title">{t("RAL1171")}</div>
                                            <div className="radio-subtitle">{t("RAL1172")}</div>
                                        </div>
                                    }
                                />
                            </Box>
                            <Box>
                                <FormControlLabel
                                    id="btn-radio-both-project"
                                    className="radio-time-project"
                                    name="btn-radio-both-project"
                                    value="all"
                                    control={
                                        <Radio
                                            id="btn-radio-both-project"
                                            sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                        />
                                    }
                                    label={
                                        <div >
                                            <div className="radio-title">{t("RAL1173")}</div>
                                            <div className="radio-subtitle">{t("RAL1174")}</div>
                                        </div>
                                    }
                                />
                            </Box>
                        </RadioGroup>
                    </FormControl>
                    <Box
                        display={"flex"}
                        flexDirection={"row-reverse"}
                        pt={5}
                    >
                        <Box item pl={1} width={"50%"}>
                            <CustomButton
                                id="btn-log-evnt"
                                variant="contained"
                                size="large"
                                fullWidth="fullWidth"
                                onClick={handleSave}
                                disabled={!hasChanges}
                            >
                                <span>{t("RAL0309")}</span>
                            </CustomButton>
                        </Box>

                        <Box item width={"50%"} pr={1}>
                            <CustomButton
                                id="btn-cancel-evnt"
                                variant="outlined"
                                size="large"
                                fullWidth="fullWidth"
                                onClick={handleCancelClick}
                                disabled={!hasChanges}
                            >
                                <span>{t("RAL0177")}</span>
                            </CustomButton>
                        </Box>
                    </Box>
                    <CancelDialog
                        open={isCancelDialogOpen}
                        onClose={handleCloseCancelDialog}
                        onConfirm={handleConfirmCancel}
                        header={t("RAL0382")}
                        message={t("RAL0743")}
                    />
                </div>
            </div>
        </ContentLayout>
    );
}

export default Project;